import React from "react";
import { Box, Heading, Text, Image, Flex } from "@chakra-ui/react";
import aboutImage from "../assets/about.png";

const AboutSection = () => {
  return (
    <Box
      id="about"
      minH="100vh"
      bg="white"
      py={10}
      display="flex"
      position="relative"
      zIndex={1}
      alignItems="center"
      justifyContent="center"
    >
      <Flex direction={{ base: "column", md: "row" }} w={{ base: "90%", md: "70%" }}>
        <Box flex="1" mr={{ base: 0, md: 6 }} mb={{ base: 6, md: 0 }}>
          <Heading as="h3" size="md" mb={4} color="gold.500">
            SOLUÇÕES LÍDERES EM EMPILHADEIRAS
          </Heading>
          <Heading as="h2" size="xl" mb={4} color="black">
            Gerenciamento logístico inovador
          </Heading>
          <Text fontSize="lg" mb={4} color="gray.700" ml={4}>
            <strong>Visão:&nbsp;</strong>Ser líder no mercado de empilhadeiras, oferecendo soluções inovadoras e eficientes para o gerenciamento de logística e armazenamento.
          </Text>
          <Text fontSize="lg" mb={4} color="gray.700" ml={4}>
            <strong>Missão:&nbsp;</strong>Fornecer empilhadeiras de alta qualidade, peças e serviços especializados, garantindo eficiência, segurança e satisfação aos nossos clientes.
          </Text>
          <Text fontSize="lg" color="gray.700" ml={4}>
            <strong>Valores:&nbsp;</strong>
          </Text>
          <Text fontSize="lg" color="gray.700" ml={12}>
            <ul>
              <li>Segurança: Protegendo pessoas e produtos.</li>
              <li>Qualidade: Entregando excelência.</li>
              <li>Inovação: Impulsionando progresso.</li>
              <li>Confiança: Construindo relacionamentos duradouros.</li>
              <li>Responsabilidade Ambiental: Preservando o futuro.</li>
            </ul>
          </Text>
        </Box>
        <Box flex="1">
          <Image src={aboutImage} alt="About Image" />
        </Box>
      </Flex>
    </Box>
  );
};

export default AboutSection;
